import React, { useCallback, useState } from 'react';
import { FiUsers } from 'react-icons/fi';
import ShareModal from '../share-modal/ShareModal';
import Tooltip from '../../common/Tooltip';

const ShareButton = ({ disabled }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = useCallback(() => setIsModalOpen(true), []);
  const closeModal = useCallback(() => setIsModalOpen(false), []);

  const tooltipTitle = disabled
    ? 'You need Owner role to be able to share this board'
    : 'Share this board';

  return (
    <>
      <Tooltip title={tooltipTitle}>
        <span>
          <button
            aria-label="share board"
            className={`action-btn ${disabled ? 'disabled' : ''}`}
            onClick={openModal}
            disabled={disabled}
            style={{ margin: 0 }}
          >
            <FiUsers size={'1.5rem'} />
          </button>
        </span>
      </Tooltip>
      <ShareModal isOpen={isModalOpen} onClose={closeModal} />
    </>
  );
};

export default ShareButton;
